<h2 mat-dialog-title class="dialog-title">
  <span>{{ dialogData.fileName || ('INBOX.WEBSITE_PREVIEW.PREVIEW_TITLE' | translate) }}</span>
  <button mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div class="preview-container">
    @if (isSupported()) {
      <div class="alert-container">
        <glxy-alert
          type="info"
          [showClose]="false"
          [showAction]="true"
          [actionTitle]="'INBOX.WEBSITE_PREVIEW.VIEW_LIVE_SITE' | translate"
          [actionExternalLink]="liveUrlForAction()"
          icon="info"
        >
          {{ 'INBOX.WEBSITE_PREVIEW.SCRAPED_CONTENT_WARNING' | translate }}
        </glxy-alert>
      </div>
    }

    @if (safeFileUrl()) {
      <div class="iframe-container">
        <iframe [src]="safeFileUrl()" class="html-preview" frameborder="0" title="File preview"> </iframe>
      </div>
    }
    @if (!dialogData.fileUrl) {
      <div class="error-message">
        <mat-icon>error</mat-icon>
        <p>{{ 'INBOX.WEBSITE_PREVIEW.NO_FILE_ERROR' | translate }}</p>
      </div>
    }
    @if (dialogData.fileUrl && !isSupported()) {
      <div class="error-message">
        <mat-icon>warning</mat-icon>
        <p>{{ 'INBOX.WEBSITE_PREVIEW.UNSUPPORTED_TYPE_ERROR' | translate }}</p>
      </div>
    }
  </div>
</mat-dialog-content>
